import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { Suspense, lazy } from 'react';
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home"; // Keep Home synchronous for LCP
import AdminRoute from './components/AdminRoute';
import MetaPixelTracker from './components/MetaPixelTracker';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Lazy Loading Heavy Components
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const UserLogin = lazy(() => import("./pages/UserLogin"));
const UserRegister = lazy(() => import("./pages/UserRegister"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const DriverProfile = lazy(() => import("./pages/DriverProfile"));
const UserProfile = lazy(() => import('./pages/UserProfile'));
const HotelProfile = lazy(() => import('./pages/HotelProfile'));
const TravelsProfile = lazy(() => import('./pages/TravelsProfile'));
const Profile = lazy(() => import('./pages/Profile'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Taxi = lazy(() => import('./pages/Taxi'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const Terms = lazy(() => import('./pages/Terms'));
const RefundCancellation = lazy(() => import('./pages/RefundCancellation'));
const SafetyGuide = lazy(() => import('./pages/SafetyGuide'));
const PassengerGuide = lazy(() => import('./pages/PassengerGuide'));
const CaptainGuide = lazy(() => import('./pages/CaptainGuide'));
const OutstationCabs = lazy(() => import('./pages/OutstationCabs'));
const VendorLogin = lazy(() => import('./pages/VendorLogin'));
const VendorDashboard = lazy(() => import('./pages/VendorDashboard'));
const BookingConfirmation = lazy(() => import('./pages/BookingConfirmation'));
const NotFound = lazy(() => import('./pages/NotFound'));



// Loading Spinner Component
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <div className="spinner-border text-success" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <MetaPixelTracker />
        <ToastContainer position="top-right" autoClose={3000} />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<MainLayout><Home /></MainLayout>} />
            <Route path="/about" element={<MainLayout><About /></MainLayout>} />
            <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/register" element={<UserRegister />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/partner/login" element={<Login />} />
            <Route path="/driver-registration" element={<Register />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <AdminRoute>
                <MainLayout><AdminDashboard /></MainLayout>
              </AdminRoute>
            } />

            {/* Territory Partner / Vendor Routes */}
            <Route path="/vendor/login" element={<VendorLogin />} />
            <Route path="/vendor" element={<VendorDashboard />} />

            <Route path="/driver/profile" element={<MainLayout><DriverProfile /></MainLayout>} />
            <Route path="/profile" element={<MainLayout><UserProfile /></MainLayout>} />
            <Route path="/hotel/profile" element={<MainLayout><HotelProfile /></MainLayout>} />
            <Route path="/travels/profile" element={<MainLayout><TravelsProfile /></MainLayout>} />
            <Route path="/privacy-policy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
            <Route path="/terms" element={<MainLayout><Terms /></MainLayout>} />
            <Route path="/refund" element={<MainLayout><RefundCancellation /></MainLayout>} />
            <Route path="/safety" element={<MainLayout><SafetyGuide /></MainLayout>} />
            <Route path="/passenger-guide" element={<MainLayout><PassengerGuide /></MainLayout>} />
            <Route path="/captain-guide" element={<MainLayout><CaptainGuide /></MainLayout>} />
            <Route path="/outstation-cabs" element={<MainLayout><OutstationCabs /></MainLayout>} />
            <Route path="/faq" element={<MainLayout><FAQ /></MainLayout>} />
            <Route path="/taxi" element={<MainLayout><Taxi /></MainLayout>} />
            <Route path="/booking-confirmation/:bookingId" element={<MainLayout><BookingConfirmation /></MainLayout>} />
            {/* 404 Catch-All Route for manual invalid URLs */}
            <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
